module.exports = __webpack_public_path__ + "media/flags/za-124a451d.svg";